import React, { useEffect, useState } from 'react'
import { CgSpinner } from 'react-icons/cg'
import styles from './Loader.module.scss'
import type { LoaderProps } from './Loader.types'

const Loader = ({ delay = 150, error }: LoaderProps) => {
  const [showLoader, setShowLoader] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(true), delay)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  if (error) {
    return <div>Error! Component failed to load</div>
  }

  if (showLoader) {
    return <CgSpinner className={styles.Loader} />
  }

  return null
}

export default Loader
